import React,{useState, useEffect} from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Javasidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Jassociation() {

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  

  
    return (
        <div>
        <Sides/>
            <Helmet>
 
 <title>Mastering Java Association: A Beginner's Guide to Understanding Object Relationships</title>
 <meta name="description" content="Learn about Java association and how to create relationships between objects with this beginner-friendly tutorial. CodeExampler provides easy-to-follow programming examples and in-depth explanations to help you master association in Java." />
<meta name="keywords" content="java association tutorial with example,association in java programming,java aggregation tutorial,composite magic number in java,codeexampler" />
<link rel="canonical" href="https://www.codeexampler.com/java-association" />
</Helmet>

<div className='lg:pl-56'>


            <h1 className="m-4 mh1">what is Association in Java</h1>
            <div className="first">
        <a href="/java-hierarchical-inheritance">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-overloading">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
 

            <h2 className='headings'>Q-Write a Program of Education Topics Example of association in Java?</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"100vh"}}>
          <code >
            {"\n"}
                <span className="qwerty">class </span>
                <span className="qwerty-4">school </span>
            {"\n"}
                <span className="qwerty-1" >&#123;</span>
            {"\n"}
                <span className="qwerty-3">  void </span>
                <span className="qwerty-8">teachers</span>
                <span className="qwerty-10">()</span>
                <span className="qwerty-1" >&#123;</span>
            {"\n"}
                <span className="qwerty-6">    System.out.println</span>
                <span className="qwerty-1">("</span>
                <span className="qwerty-10">teaching</span>
                <span className="qwerty-1">")</span>
                <span className="qwerty-1">;</span>
            {"\n"}
                <span className="qwerty-1" >  &#125;</span>
            {"\n"}
                <span className="qwerty-3">  void </span>
                <span className="qwerty-8">students</span>
                <span className="qwerty-10">()</span>
                <span className="qwerty-1" >&#123;</span>
            {"\n"}
                <span className="qwerty-6">    System.out.println</span>
                <span className="qwerty-1">("</span>
                <span className="qwerty-10">learn</span>
                <span className="qwerty-1">")</span>
                <span className="qwerty-1">;</span>
            {"\n"}
                <span className="qwerty-1" >  &#125;</span>
            {"\n"}        
                    <span className="qwerty-7">  public </span>
                    <span className="qwerty">static </span>
                    <span className="qwerty-3">void </span>
                    <span className="qwerty-8">main</span>
                    <span className="qwerty-1">(</span>
                    <span className="qwerty-2">String</span>
                    <span className="qwerty-6">[]</span>
                    <span className="qwerty-4">args</span>
                    <span className="qwerty-1">)</span>
            {"\n"}
                <span className="qwerty-1" >  &#123;</span>
            {"\n"}
                <span className="qwerty-6">    System.out.println</span>
                <span className="qwerty-1">("</span>
                <span className="qwerty-10">start method</span>
                <span className="qwerty-1">")</span>
                <span className="qwerty-1">;</span>
            {"\n"}
                    <span className="qwerty-4">    school </span>
                    <span className="qwerty-5">s</span>
                    <span className="qwerty-1"> = </span>
                    <span className="qwerty">new </span>
                    <span className="qwerty-4">school</span>
                    <span className="qwerty-10">()</span>
                    <span className="qwerty-1">;</span>
            {"\n"}
                <span className="qwerty-5">    s</span>
                <span className="qwerty-1">.</span>
                <span className="qwerty-8">teachers</span>
                <span className="qwerty-10">()</span>
                <span className="qwerty-1">;</span>        
                    {"\n"}          
                         <span className="qwerty-10" >//s.students();</span>  
                         <span className="qwerty-5" >  //second method but don't we use</span>
                    {"\n"}          
                         <span className="qwerty-1" > &#125;</span>{"\n"}
                         <span className="qwerty-1" >&#125;</span>
                {"\n"}   {"\n"}    
        </code>
        </pre>
        </div>          
        <h5 className='headings'> Output : </h5>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
            <pre style={{maxHeight:"100vh"}}>
                <code >
                    {"\n"}
                        <span className="qwerty-3">start method</span>
                    {"\n"}
                        <span className="qwerty-2">teaching</span>
                        {"\n"}      {"\n"}      
              </code>
                </pre>
                </div>

 <h1 className="mt-5">  </h1>
 <div className="back">
        <a href="/java-hierarchical-inheritance">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-overloading">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
    )

}
export default Jassociation;